<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0322 3.05334C20.2938 2.94495 20.5948 3.00481 20.7951 3.20499C20.9952 3.40518 21.055 3.70625 20.9467 3.96778L14.0632 20.5685C13.9451 20.8529 13.6551 21.0267 13.3486 20.9966C13.0421 20.9666 12.7913 20.7398 12.7308 20.4379L11.2023 12.7977L3.56212 11.2693C3.26022 11.2087 3.0334 10.9579 3.00336 10.6514C2.97331 10.3449 3.1471 10.0548 3.43148 9.93681L20.0322 3.05334Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
